<p-panel styleClass="panel-shadow" class="driver-notes" [style]="{ 'margin-bottom': '1em' }">
  <p-header>
    <div class="panel-header">MoDel PIN</div>
  </p-header>
  <div class="flex align-items-center flex-wrap" [class.ghost]="!modelPinTask">
    <div
      class="flex-grow-1 grid-label-value"
      *ngIf="modelPinTask?.moDelPin?.length > 0; else noPin"
    >
      <div class="white-space-nowrap">
        <span class="mr-1">PIN Number:</span>
      </div>
      <div class="ghost-fill value">
        <span class="model-pin-bold ml-1">{{ modelPinTask?.moDelPin }}</span>
      </div>
    </div>

    <ng-template #noPin>
      <div class="flex-grow-1" style="color: #999; font-weight: 500">No PIN Provided</div>
    </ng-template>

    <div class="flex-shrink-1">
      <div *ngIf="organisationTypeId == 1 || organisationTypeId == 2">
        <button
          pButton
          label="Change"
          class="ui-button-secondary btn-mobile-block"
          (click)="showMoDelPinDialog()"
        ></button>
      </div>
    </div>
  </div>
</p-panel>

<p-dialog
  header="MoDel PIN"
  [(visible)]="isShownMoDelPin"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '350px' }"
>
  <div class="style2023 p-3">
    <div class="input-group">
      <div class="input-group-prepend">PIN</div>
      <div class="input-group-item">
        <input
          [(ngModel)]="moDelPin"
          maxlength="7"
          style="width: 100%"
          (keydown)="inputHelper.allowNumberInputKey($event, false)"
          (keyup)="inputHelper.fixDigits($event.target)"
          pInputText
        />
      </div>
    </div>
  </div>
  <p-footer class="rounded-bottom-border">
    <button
      type="button"
      pButton
      label="Close"
      (click)="isShownMoDelPin = false"
      class="ui-button ui-button-tertiary mr-2"
    ></button>
    <button
      type="button"
      pButton
      icon="fa ui-icon-check"
      label="Save"
      class="ui-button green-btn"
      (click)="saveMoDelPin()"
    ></button>
  </p-footer>
</p-dialog>
